import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeRequests: 0,
  isLoading: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: (state, action) => {
      state.activeRequests += 1;
      state.isLoading = true;
    },
    hideLoader: (state) => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      state.isLoading = state.activeRequests > 0;
    },
    resetLoader: (state) => {
      state.activeRequests = 0;
      state.isLoading = false;
    },
  },
});

export const { showLoader, hideLoader, resetLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
